import {Component} from '@angular/core';

@Component({
    selector: 'app-attribution',
    templateUrl: './attribution.component.html',
    styleUrl: './attribution.component.scss',
    standalone: false
})
export class AttributionComponent {

}
